import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import { useState } from 'react'
import type _Account from 'mobx/Account'
import SavedAddresses from './SavedAddresses'
import AddressEntry from './AddressEntry'
import { injectStores } from 'mobx/injection'

interface AddressSelectionProps {
	Account?: typeof _Account
}

const AddressSelection = ({ Account }: AddressSelectionProps) => {
	const { localizationStore } = useStores()
	const initiallyShowSavedAddresses =
		localizationStore.savedAddressesEnabled &&
		!!Account?.isAuthenticated() &&
		localizationStore.savedAddresses.length > 0 &&
		!localizationStore.startedFromSavedAddress
	const [showSavedAddresses, setShowSavedAddresses] = useState<boolean>(initiallyShowSavedAddresses)

	const goBack = () => {
		if (showSavedAddresses === initiallyShowSavedAddresses) {
			localizationStore.previousStep()
		} else {
			setShowSavedAddresses(!showSavedAddresses)
		}
	}

	const goToSavedAddresses = () => {
		if (localizationStore.savedAddressesEnabled) {
			setShowSavedAddresses(true)
		}
	}

	const goToAddressEntry = () => {
		setShowSavedAddresses(false)
	}

	return showSavedAddresses ? (
		<SavedAddresses goToAddressEntry={goToAddressEntry} goBack={goBack} />
	) : (
		<AddressEntry goToSavedAddresses={goToSavedAddresses} goBack={goBack} />
	)
}

export default injectStores('Account')(observer(AddressSelection))
